// src/ThemeToggle.js
import React from 'react';
import './ThemeToggle.css';

const ThemeToggle = ({ theme, onToggle }) => {
  const isLightMode = theme === 'light-mode';

  return (
    <div className="theme-toggle-container">
      <label htmlFor="theme-toggle" className="theme-toggle-label">
        <div className={`toggle-switch ${isLightMode ? 'light' : 'dark'}`}>
          <input
            id="theme-toggle"
            type="checkbox"
            checked={isLightMode}
            onChange={onToggle}
          />
          <span className="slider"></span>
        </div>
        <span className="toggle-text">{isLightMode ? 'Light Mode' : 'Dark Mode'}</span>
      </label>
    </div>
  );
};

export default ThemeToggle;